import styled from "styled-components"
import P from "../P"
import { device } from "../../themes/device"

const SubTitle = styled(P)`
  ${props => props.center && "text-align: center;"}
  ${props => props.right && "text-align: right;"}
  margin-bottom: 32px;
  font-weight: normal;

  @media ${device.desktopL} {
    margin-bottom: 0px;
  }
`

export default SubTitle
